import type { ReactNode } from 'react';

import * as styles from './styles.css';

export const Underline = ({ children }: { children: ReactNode }) => (
  <span className={styles.underline}>{children}</span>
);
